









import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class SiteAdmin extends Vue {
  selectedSiteId: number | null = null;
  siteSearch: string | null = null;
  activeTab = 0;
  activeValue = '员工系统';
  options: Array<{ text: string; value: number }> = [];

  async mounted() {
    let routeSiteId = parseInt(this.$route.params.id);
    if (!routeSiteId) {
      routeSiteId = 0;
    }
    await this.$store.dispatch('sites/refresh');
    for (const site of this.$store.state.sites.all) {
      this.options.push({ text: site.title, value: site.id });
    }
    if (Number.isInteger(routeSiteId)) {
      await this.$router.push(
        { name: 'SiteDetail', params: { id: routeSiteId.toString() } },
        () => null,
        () => null
      );
      await this.onChange(routeSiteId);
    }
  }

  onChange(index: number) {
    const result = this.options.filter(item => {
      return item.value == index;
    });
    if (!result || !result[0]) {
      this.$router.replace({ name: 'SiteDetail', params: { id: '0' } });
    } else {
      this.activeValue = result[0].text;
      this.$router.replace({ name: 'SiteDetail', params: { id: result[0].value.toString() } });
    }
  }
}
